module.exports = __webpack_public_path__ + "img/retroalimentacion.bf50d592.jpg";